import {
  Container,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import RepairJourney from "../RepairJourney";
import Button from "../../Button/Button";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import {
  userChosenEmergencyQuestion,
  isEditState,
  userChosenDuplicateQuestion,
  backToRepairAsset,
  userChosenNotifyAll,
  userChosenAdditionalDescription,
} from "../../ducks/redux/actions/userChoices";
import * as api from "../../api";
import { priorityCode, selectedRepairReasonDefaultPriority, selectedRepairReasonPriorityOverride } from "../../ducks/redux/actions/dashboardReducer.actions";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import { RepairPriorityCode } from "../../models/Repair/CreateRepair";
import { Helper } from "../../utils/Helper/HelperUtil";
import { PermissionsList } from "../../models/Permissions";


interface RepairEDEmergencyProps extends RouteComponentProps<any> { }
const RepairEDEmergency: React.FC<RepairEDEmergencyProps> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [radiovalue, setRadioValue] = useState("");
  const [isBackModalOpen, setIsBackModalOpen] = useState(false);
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );

  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );

  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const assetDetails = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const customerDetails = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const customerAdditionalAlertData = useSelector((state: any) => state?.userChoicesReducer?.customerAdditionalAlertData);
  const isAnaTypeValue = customerAdditionalAlertData?.length > 0;
  const [emergencyAlertText, setEmergencyAlertText] = useState("RepairLocation_No_Emergency_Text");
  const repairDiagnosticData = useSelector((state: any) => state?.userChoicesReducer?.repairDiagnosticFinalData);
  const isHHSRSEnabled = useSelector((state: any) => state?.financialReferralReducer?.isHHSRSEnabled)
  const isHHSRSRole = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.update_digital_journey_hhsrs_hazard_repair);
  const selectedRepairReason = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);

  const SetEmergencyMessage = (priority: string) => {
    if (priority === RepairPriorityCode.Emergency) {
      setEmergencyAlertText("RepairLocation_Emergency_Text");
    } else {
      priority === RepairPriorityCode.DampAndMould ?
        setEmergencyAlertText("RepairLocation_DM_Text")
        : priority === RepairPriorityCode.V14 ?
          setEmergencyAlertText("RepairLocation_V14_Text")
          : setEmergencyAlertText("RepairLocation_No_Emergency_Text");
    }
  }

  useEffect(() => {
    if (workOrderObject?.priority === RepairPriorityCode.Emergency || workOrderObject?.priority === RepairPriorityCode.OutOfHours) {
      setRadioValue(t("Repair_ED_Emergency_Radio1_Text"));
      dispatch(userChosenEmergencyQuestion(t("Repair_ED_Emergency_Radio1_Text")));
      setEmergencyAlertText("RepairLocation_Emergency_Text");
    } else if (workOrderObject?.priority === RepairPriorityCode.NextAvailable) {
      setRadioValue(t("Repair_ED_Emergency_Radio2_Text"));
      dispatch(userChosenEmergencyQuestion(t("Repair_ED_Emergency_Radio2_Text")));
      setEmergencyAlertText("RepairLocation_No_Emergency_Text");
    }
    else if (workOrderObject?.priority === RepairPriorityCode.V14) {
      setRadioValue(t("Repair_ED_Emergency_Radio2_Text"));
      dispatch(userChosenEmergencyQuestion(t("Repair_ED_Emergency_Radio2_Text")));
      setEmergencyAlertText("RepairLocation_V14_Text");
    }
    else {
      setRadioValue(t("Repair_ED_Emergency_Radio2_Text"));
      dispatch(userChosenEmergencyQuestion(t("Repair_ED_Emergency_Radio2_Text")));
      setEmergencyAlertText("RepairLocation_No_Emergency_Text");
    }

  }, [t, dispatch, repairDiagnosticData?.priority]);

  const fetchDeterminedPriority = async (
    workOrderObject: any,
    assetDetails: any,
    customerDetails: any,
    isAnaTypeValue: boolean
  ) => {
    try {
      const repairPriorityPayload = {
        isEmergency: workOrderObject.isEmergency,
        repairType: workOrderObject.sorCode,
        description: workOrderObject.description,
        channel: "ColleagueSelfServe",
        raisedDate: new Date().toISOString(),
        isAnaType: isAnaTypeValue,
        tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
        isV14Upgradable: repairDiagnosticData.isV14Eligibile ?? false,
        workProgramme: workOrderObject.workProgramme,
        premisesType: assetDetails?.assetType,
        hasSeasonalPriority:selectedRepairReason?.[0]?.hasSeasonalPriority ?? false
      };

      const result = await api.repairPriorityDetermination(repairPriorityPayload);
      return result?.repairPriority ?? workOrderObject?.priority;
    } catch (err) {
      console.error("repairPriorityDetermination failed", err);
      props.history.push("/GenericError");
    }
  };


  const updateSelection = async (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    if (EditState === true) {
      dispatch(userChosenNotifyAll(null));
      dispatch(userChosenAdditionalDescription(""));
      dispatch(isEditState(false));
      dispatch(userChosenDuplicateQuestion(""));
    }
    setRadioValue(value);
    dispatch(userChosenEmergencyQuestion(value));

    if (value === t("Repair_ED_Emergency_Radio2_Text")) {
      //Check only if user changes to "No", as we are only overriding NA scenarios to V14 & DM
      // DME related question are answered at later changes, and that priority will be handled there
      workOrderObject.isEmergency = false;
      const determinedPriority = await fetchDeterminedPriority(
        workOrderObject,
        assetDetails,
        customerDetails,
        isAnaTypeValue
      );
      workOrderObject.priority = determinedPriority;

      dispatch(priorityCode(determinedPriority));
      SetEmergencyMessage(determinedPriority ?? workOrderObject.priority);
      const selectedPriority =
        Helper.RepairPriorityLabels[determinedPriority as keyof typeof Helper.RepairPriorityLabels] ||
        determinedPriority;
      dispatch(selectedRepairReasonDefaultPriority(selectedPriority));
      dispatch(selectedRepairReasonPriorityOverride(determinedPriority));

    } else {
      setEmergencyAlertText("RepairLocation_Emergency_Text");
      workOrderObject.isEmergency = true;
      workOrderObject.priority = RepairPriorityCode.Emergency;
      dispatch(priorityCode(RepairPriorityCode.Emergency));
      const selectedPriority =
        Helper.RepairPriorityLabels[RepairPriorityCode.Emergency as keyof typeof Helper.RepairPriorityLabels] ||
        RepairPriorityCode.Emergency;
      dispatch(selectedRepairReasonDefaultPriority(selectedPriority));
      dispatch(selectedRepairReasonPriorityOverride(RepairPriorityCode.Emergency));
    }
  };


  const backButtonHandler = () => {
    if (isHHSRSEnabled && isHHSRSRole) {
      props.history.push("/hhsrs")
    } else {
      setIsBackModalOpen(true)
    }
  };

  const handleBackLeave = () => {
    setIsBackModalOpen(false);
    props.history.replace("/RepairTradeCategory");
  };

  const exitButtonHandler = () => {
    dispatch(backToRepairAsset(false))
    props.history.push("/LandingView");
  };

  //updating the work order as per the selected radio button
  const UpdateEDWorkOrder = async () => {
    try {
      let userChosenEmergencyRadio = radiovalue === t("Repair_ED_Emergency_Radio1_Text");
      if (userChosenEmergencyRadio) {
        workOrderObject.isEmergency = true;
        workOrderObject.VulnerableResponseText = null;
        workOrderObject.isVulnerable = false;
      } else {
        workOrderObject.isEmergency = false;
      }

      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(workOrderObject);

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );

      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    }
  };

  const callPageHandler = () => {
    UpdateEDWorkOrder();
    dispatch(userChosenEmergencyQuestion(radiovalue));
    props.history.push("/DuplicateRepair");
  };

  return (
    <>
      <Container id="repairemergencyED" role="main" className="ctn-fht">
        {
          <main className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0">
            <div className="back-and-journey">
              <p className="text-teal text-xl mt-4 mb-8">
                <button data-testid="back-button" className="back-btn" onClick={backButtonHandler}>
                  <i className="fas fa-angle-left mr-2"></i>
                  {t("back")}
                </button>
              </p>
              <ExitModalAndSave
                id="repairemer-back-exitmodal"
                open={isBackModalOpen}
                modalTitle={
                  <span style={{ color: "#A64CA6", fontWeight: 600 }}>
                    {t("ED_EME_BACKMODAL_TITLE")}
                  </span>}
                modalSubtitle={t("ED_EME_BACKMODAL_SUBTITLE")}
                stayButtonText={t("ED_EME_STAYBUTTONTEXT")}
                leaveButtonText={t("D_EME_LEAVEBUTTONTEXT")}
                closeAfterSaving={false}
                canSaveAndExit={false}
                showBackOnly={true}
                onLeave={handleBackLeave}
                onClose={() => setIsBackModalOpen(false)}
              />
              <RepairJourney />
            </div>
          </main>
        }
        <div className="container">
          <div id="repairemer-main-div" className="h5 my-3 repair-text">
            <p
              id="repairemer-h1"
              className="text-purple-100 text-2xl mb-2 global-txt"
            >
              {t("Advanced_RepairRole_Emergency_Header_Text")}
            </p>
          </div>
          <div id="repairemer-div1" className="repair-text mb-12">
            <RadioGroup
              id="repairemer-radiogrp"
              className="mb-2"
              onChange={updateSelection}
              defaultValue={radiovalue}
              value={radiovalue}
            >
              <fieldset><legend>
                <FormControlLabel
                  id="repairemer-label1"
                  value={t("Repair_ED_Emergency_Radio1_Text")}
                  control={<Radio id="repairemer-radio1" />}
                  label={t("Repair_ED_Emergency_Radio1_Text")}
                  placeholder="yes"
                />
              </legend></fieldset>
              <fieldset><legend>
                <FormControlLabel
                  id="repairemer-label2"
                  value={t("Repair_ED_Emergency_Radio2_Text")}
                  control={<Radio id="repairemer-radio2" />}
                  label={t("Repair_ED_Emergency_Radio2_Text")}
                  placeholder="next"
                />
              </legend></fieldset>
            </RadioGroup>
            <div className="alert mt-8 p-0 container" role="alert">
              <div className="w-full px-2 bg-purple-20 flex items-center">
                <div className="px-4 pr-8">
                  <i className="fa fa-bullhorn text-purple-100 w-6 purple-icon"></i>
                </div>
                <div className="flex items-center text-black" data-testid="alertWarning">
                  <p className="w-full text-left mt-2 font-AvantGardeGothic-Md">
                    {t(emergencyAlertText)}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div
          className="flex justify-between items-center pb-4 md:pb-8 container"
          id="repairemer-main-btn"
        >
          <ExitModalAndSave
            id="repairemer-exitmodal"
            exit={exitButtonHandler}
            closeAfterSaving={false}
          />
          <Button
            id="repairemer-btn1"
            data-testid="continue"
            onClick={callPageHandler}
            className="button-class"
          >
            {t("continue")}{" "}
            <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
          </Button>
        </div>
      </Container>
    </>
  );
};

export default RepairEDEmergency;